import { createQuery } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const GetResourceAgendaTeamScheduleResponseSchema = z.array(
  z.object({
    id: z.number(),
    board: z.number(),
    display_name: z.string().nullish(),
    tasks: z.array(
      z.object({
        start_time: z.string(),
        end_time: z.string(),
        display_name: z.string(),
        color: z.string(),
        style: z.string().nullish(),
        id: z.number()
      })
    ),
    label: z.string().nullish()
  })
);

export type GetResourceAgendaTeamScheduleResponse = z.infer<
  typeof GetResourceAgendaTeamScheduleResponseSchema
>;

const GetResourceAgendaTeamScheduleRequestSchema = z.object({
  start_datetime: z.string(),
  end_datetime: z.string(),
  board_ids: z.array(z.number())
});

export type GetResourceAgendaTeamScheduleRequest = z.infer<
  typeof GetResourceAgendaTeamScheduleRequestSchema
>;

export const useGetResourceAgendaTeamSchedule = createQuery<
  GetResourceAgendaTeamScheduleResponse,
  GetResourceAgendaTeamScheduleRequest,
  Error
>({
  queryKey: ["resourceAgendaTeamSchedule"],
  staleTime: 1000 * 60,
  fetcher: async (variables) => {
    // console.log({ variables });
    return api<
      GetResourceAgendaTeamScheduleRequest,
      GetResourceAgendaTeamScheduleResponse
    >({
      method: "GET",
      // url: `/resource/team-schedule?${boardsString}&start_datetime=:start_datetime&end_datetime=:end_datetime`,
      url: `/resource/team-schedule`,
      requestSchema: GetResourceAgendaTeamScheduleRequestSchema,
      responseSchema: GetResourceAgendaTeamScheduleResponseSchema,
      body: variables
    });
  }
});
